/**
 * This function checks if the layer ID matches a pattern for a given utility's reference layer type.
 * @param {string} layerId - the ID of the layer to check
 * @param {"poles"|"primary"|"secondary"} layerType - the type of layer to check for
 * @param {string} [utilityOverride] - the key for the utility company. If not provided, it will use the utility company from the config.
 * @returns {boolean} - true if the layer ID matches the pattern for the given utility's reference layer type, false otherwise
 */
export function LayerIdIsUtilityRefLayerType(layerId, layerType, utilityOverride) {
  const utilityCompany = utilityOverride || this.config.firebaseData.utilityCompany;
  switch (layerType) {
    case 'poles':
      return layerId?.includes(`${utilityCompany}--poles`) || layerId?.includes(`${utilityCompany}--pole_attributes_imports`);
    case 'primary':
      return layerId?.includes(`${utilityCompany}--primary_overhead`) || layerId?.includes(`${utilityCompany}--primary_overhead_imports`);
    case 'secondary':
      return (
        layerId?.includes(`${utilityCompany}--secondary_overhead`) || layerId?.includes(`${utilityCompany}--secondary_overhead_imports`)
      );
    default:
      return false;
  }
}
